import React from "react";
import PropTypes from "prop-types";

import { useReleases } from "./hooks/useReleases";

import { ModalContainer } from "./styles";
import ReleasesUploadError from "./ReleasesUploadError";

import ReleaseUploadButton from "./ReleaseUploadButton";

const ManageReleasesModal = ({ numReleasesUploaded, onClose, isModalOpen }) => {
    const { ReleasesBanners } = useReleases();

    const determineHeading = () => {
        if (numReleasesUploaded === 1) {
            return `${numReleasesUploaded} Release For This Batch`;
        } else if (numReleasesUploaded > 1) {
            return `${numReleasesUploaded} Releases For This Batch`;
        } else {
            return "Releases For This Batch";
        }
    };

    const heading = determineHeading();

    const footerChildren = <ReleaseUploadButton />;

    return (
        <ModalContainer
            open={isModalOpen}
            onClose={onClose}
            handleClose={onClose}
            heading={heading}
            footerChildren={footerChildren}
        >
            <ReleasesUploadError />

            <ReleasesBanners />
        </ModalContainer>
    );
};

ManageReleasesModal.propTypes = {
    numReleasesUploaded: PropTypes.number.isRequired,
    onClose: PropTypes.func.isRequired,
    isModalOpen: PropTypes.bool.isRequired
};

export default ManageReleasesModal;
